'use client';

import {useContext, useState} from "react";
import Image from "next/image";
import {useRouter} from 'next/navigation';
import Seeker from "@/app/assets/images/registration/seeker.svg";
import Mediator from "@/app/assets/images/registration/mediator.svg";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import {registerService} from "@/app/services/RegisterService";
import FormContext from "@/app/context/FormContext";
import classes from "./Role.module.scss";
import {useTranslation} from "react-i18next";

const Role = () => {
    const [selectedRole, setSelectedRole] = useState('');
    const {firstStep, secondStep} = useContext(FormContext);
    const router = useRouter();
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);

    const selectRole = (role) => {
        const roleId = role === 'Seeker' ? 1 : 2;
        setSelectedRole(roleId);
    };

    const finalizeRegistration = () => {
        setLoading(true);
        const registrationData = {
            ...firstStep,
            ...secondStep,
            country_id: secondStep.country_id ? secondStep.country_id.value : null,
            city_id: secondStep.city_id ? secondStep.city_id.value : null,
            role_id: selectedRole,
        };

        registerService.register(registrationData).then(response => {
            router.push('/register/registration-complete');
        }).catch(error => {
        });
    };

    return (
        <main>
            <div className={classes.container}>
                <div className={classes.progressRegistration}>
                    <div className={classes.progressFilled}/>
                </div>

                <div className={classes.role}>
                    <div className={classes.frame}></div>
                    <div className={classes.rolesContainer}>
                        <h1>{t('role.select')}</h1>
                        <div className={classes.roles}>
                            <div className={classes.roleContainer}>
                                <div onClick={() => selectRole('Seeker')}
                                     className={`${classes.roles_border} ${selectedRole === 1 ? classes.selected_role : ''}`}>
                                    <Image
                                        src={Seeker}
                                        alt="seeker"
                                    />
                                    <span>{t('role.seeker')}</span>
                                    <p className={classes.seekerInfo}>{t('role.needConection')}</p>
                                </div>
                                <p className={classes.offerSeeker}>{t('role.needConection')}</p>
                            </div>
                            <div className={classes.roleContainer}>
                                <div onClick={() => selectRole('Mediator')}
                                     className={`${classes.roles_border} ${selectedRole === 2 ? classes.selected_role : ''}`}>
                                    <Image
                                        src={Mediator}
                                        alt="mediator"
                                    />
                                    <span>{t('role.mediator')}</span>
                                    <p className={classes.mediatorInfo}>{t('role.offerConection')}</p>
                                </div>
                                <p className={classes.offerMediator}>{t('role.offerConection')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <RoundedButton
                    type="primary"
                    onClick={finalizeRegistration}
                    disabled={!selectedRole}
                    loading={loading}
                >
                    {t('finish')}
                </RoundedButton>
            </div>
        </main>
    )
}

export default Role;